import React from "react";

const Footer = () => {
  return (
    <footer className="bg-light all-center py-1" style={{ marginTop: "15px" }}>
      <p>
        Created by{" "}
        <a
          href="https://zihadsweb.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Zihad Ul Islam
        </a>
      </p>
    </footer>
  );
};

export default Footer;
